<template>
  <div class="addCount">
    <div class="name">
      {{ moduleTitle }}
    </div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleFormAddCount"
      label-width="100px"
    >
      <el-form-item label="账户名" prop="countName">
        <el-input
          v-model="ruleForm.countName"
          :maxlength="32"
          placeholder="请输入账户名"
        ></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="userName">
        <el-input
          v-model="ruleForm.userName"
          :maxlength="32"
          placeholder="请输入姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label="电子邮箱" prop="email">
        <el-input
          v-model="ruleForm.email"
          placeholder="请输入电子邮箱"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号码" prop="phone">
        <el-input
          v-model="ruleForm.phone"
          placeholder="请输入手机号码"
        ></el-input>
      </el-form-item>
      <el-form-item label="部门" prop="department">
        <template v-if="selectDepart.length !== 0">
          <el-input
            v-for="item in selectDepart"
            :key="item.id"
            :value="item.name"
            readonly
          >
          </el-input>
        </template>
        <template v-else>
          <el-input readonly placeholder="请选择部门"></el-input>
        </template>
        <el-button type="text" @click="openSetDepart">设置</el-button>
      </el-form-item>
      <el-form-item label="启用状态" prop="enable">
        <el-switch v-model="ruleForm.enable"></el-switch>
      </el-form-item>
      <el-form-item label="管理员" prop="managered">
        <el-switch v-model="ruleForm.managered"></el-switch>
        <span class="testTip">管理员具有IDS管理平台所有权限</span>
      </el-form-item>
      <el-form-item>
        <div class="footer">
          <el-button type="primary" @click="submitForm">确 定</el-button>
          <el-button @click="handleCancel">取 消</el-button>
        </div>
      </el-form-item>
    </el-form>
    <DialogSetDepart
      ref="dialogSetDepart"
      :selectAccount="selectAccount"
      :department="department"
      @setDepartment="setDepartment"
    ></DialogSetDepart>
  </div>
</template>

<script>
import { validatePhone, flatten } from "@/common/utils.js"
import DialogSetDepart from "@/components/common/Dialog/setDepart.vue"
import APIS from "@/apis/userManage.js"
import DepartAPIS from "@/apis/department.js"
export default {
  components: {
    DialogSetDepart
  },
  data() {
    const checkCountName = (rule, value, callback) => {
      let pattern = /^[a-zA-Z][0-9a-zA-Z-_.]{3,31}$/
      value = value.trim()
      if (value === "") {
        callback(new Error("请输入账户名"))
      } else if (!pattern.test(value)) {
        callback(
          new Error(
            "必须以字母开头,支持大写字母、小写字母、数字、中划线(-)、下划线(_)、点(.)，长度至少 4 位"
          )
        )
      } else {
        callback()
      }
    }
    const checkDepartment = (rule, value, callback) => {
      if (this.selectDepart.length === 0) {
        callback(new Error("请选择部门名称"))
      } else {
        callback()
      }
    }
    return {
      breadcrumb: [
        {
          label: "账户管理",
          url: "/userManage"
        },
        {
          label: "新建账户"
        }
      ],
      moduleTitle: "新建账户",
      ruleForm: {
        countName: "",
        userName: "",
        phone: "",
        email: "",
        enable: true,
        department: [],
        managered: false
      },
      rules: {
        countName: [
          { required: true, validator: checkCountName, trigger: "blur" }
        ],
        userName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        email: [
          { required: true, message: "请输入电子邮箱", trigger: "blur" },
          {
            type: "email",
            message: "请输入格式正确的邮箱地址",
            trigger: "blur"
          }
        ],
        phone: [{ validator: validatePhone, trigger: "blur" }],
        department: [
          { required: true, validator: checkDepartment, trigger: "blur" }
        ]
      },
      realmName: this.$realm, //this.$realm,
      department: [],
      selectDepart: [],
      selectAccount: []
    }
  },
  computed: {},
  mounted() {
    this.getDepartments()
  },
  methods: {
    // 获取部门列表
    async getDepartments() {
      let { status, data } = await DepartAPIS.getDepartments(this.realmName)
      this.department = []
      this.selectDepart = []
      if (status === 0) {
        this.department = data
        if (data && data[0]) {
          this.selectDepart = [
            {
              id: data[0].id,
              name: data[0].name,
              path: data[0].path
            }
          ]
        }
      }
    },
    async addUser() {
      let params = {
        username: this.ruleForm.userName,
        accountname: this.ruleForm.countName,
        enabled: this.ruleForm.enable,
        email: this.ruleForm.email,
        telephone: this.ruleForm.phone,
        departments: this.selectDepart,
        managered: this.ruleForm.managered
      }
      let { status, data } = await APIS.postRealmsUsers(this.realmName, {
        data: params
      })
      if (status === 0 && data && data.id) {
        this.$router.push({
          path: "/userManage/detailCount",
          query: {
            accountId: data.id,
            flag: "1"
          }
        })
      }
    },
    // 提交添加账户表单
    submitForm() {
      this.$refs["ruleFormAddCount"].validate(valid => {
        if (valid) {
          this.addUser()
        }
      })
    },
    // 打开设置部门弹窗
    openSetDepart() {
      // 此处selectAccount不能放在计算属性中，弹窗消失后，里面的tree会初始化状态。如果放在计算属性中，则有可能计算后的值，在弹窗消失后被初始化了
      this.selectAccount =
        this.selectDepart.length === 0
          ? []
          : [
              {
                department: this.selectDepart
              }
            ]
      this.$nextTick(() => {
        this.$refs.dialogSetDepart.dialogSetDepartVisible = true
      })
    },
    handleCancel() {
      this.$router.push("/userManage")
    },
    // 确认设置部门信息
    setDepartment({ remDepartIds, addDepartIds }) {
      remDepartIds.length &&
        remDepartIds.forEach(id => {
          let index = this.selectDepart.findIndex(item => item.id === id)
          this.selectDepart.splice(index, 1)
        })
      addDepartIds.length &&
        addDepartIds.forEach(id => {
          let item = flatten(this.department, "subGroups").find(
            item => item.id === id
          )
          this.selectDepart.push({
            id: item.id,
            name: item.name,
            path: item.path
          })
        })
      this.$refs.dialogSetDepart.dialogSetDepartVisible = false
    }
  }
}
</script>

<style lang="scss">
.addCount {
  .name {
    margin-bottom: 16px;
    padding-left: 26px;
  }
  .el-form-item__error {
    white-space: nowrap;
  }
  .el-form-item__content {
    .testTip {
      color: #999;
      font-size: 13px;
      margin-left: 20px;
      vertical-align: middle;
    }
    .el-button--text {
      position: absolute;
      margin-left: 14px;
      top: 6px;
    }
  }
}
</style>
